import { isSameDayDate } from '@paradigm/utils/src/date';

type Expiration = number | null | undefined;

export function areExpirationsEqual(exp1: Expiration, exp2: Expiration) {
  if (exp1 === undefined || exp2 === undefined) return false;
  if (exp1 !== null && exp2 !== null) return isSameDayDate(exp2, exp1);

  // They are both Perpetual
  return exp1 === null && exp2 === null;
}
